// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Fo-z","slideIn":"Go-z"};